import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import GigWorker from 'types/worker'
import {
  Candidate,
  CandidateDetail,
  CandidateSearchParameter,
  JobCandidateStaffUpdatePayload,
} from 'types/job_candidate'
import { JobCandidateTag } from 'types/job_candidate_tag'
import type { RecruitmentStep } from 'types/recruitment_step'
import { mergeURL } from './lib'
import { RecruitmentOfferPayload } from 'types/recruitment_offer'

const resource = 'job_candidates'

export const requests = {
  fetchCandidates: (
    parameter: CandidateSearchParameter,
    page: number,
    limit: number,
  ) => {
    return axiosForGigbaseBiz.get<DataResponse<Candidate[]>>(resource, {
      params: {
        ...parameter,
        support_status: 'active',
        page,
        limit,
      },
    })
  },
  fetchUnprocessedCount: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<{ total: number }>>(
      `${resource}/unprocessed_count`,
    )
  },
  fetchOnProcessingCount: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<{ total: number }>>(
      `${resource}/processing_count`,
    )
  },
  fetchClosedCandidates: (
    parameter: CandidateSearchParameter,
    page: number,
    limit: number,
  ) => {
    return axiosForGigbaseBiz.get<DataResponse<Candidate[]>>(resource, {
      params: {
        ...parameter,
        support_status: 'close',
        page,
        limit,
      },
    })
  },
  fetchCandidate: (jobCandidateId: string) => {
    return axiosForGigbaseBiz.get<DataResponse<CandidateDetail>>(
      mergeURL(resource, jobCandidateId.toString()),
    )
  },
  fetchWorkers: () => {
    return axiosForGigbaseBiz.get<DataResponse<GigWorker[]>>(
      mergeURL(resource, 'workers'),
    )
  },
  fetchRecruitmentSteps: (jobCandidateId: number) => {
    return axiosForGigbaseBiz.get<DataResponse<RecruitmentStep[]>>(
      `${resource}/${jobCandidateId}/recruitment_steps`,
    )
  },
  updateRecruitmentStep: (
    jobCandidateId: number,
    recruitmentStepId: number,
  ) => {
    return axiosForGigbaseBiz.post<DataResponse<void>>(
      `${resource}/${jobCandidateId}/update_recruitment_step`,
      {
        recruitment_step_id: recruitmentStepId,
      },
    )
  },
  activate: (jobCandidateId: number) => {
    return axiosForGigbaseBiz.post<DataResponse<void>>(
      `${resource}/${jobCandidateId}/activate`,
    )
  },
  close: (jobCandidateId: number) => {
    return axiosForGigbaseBiz.post<DataResponse<void>>(
      `${resource}/${jobCandidateId}/close`,
    )
  },
  tag: (jobCandidateId: number, tagId: number) => {
    return axiosForGigbaseBiz.post<DataResponse<JobCandidateTag>>(
      `${resource}/${jobCandidateId}/tag`,
      {
        branch_candidate_tag_id: tagId,
      },
    )
  },
  untag: (jobCandidateId: number, tagId: number) => {
    return axiosForGigbaseBiz.post<DataResponse<void>>(
      `${resource}/${jobCandidateId}/untag`,
      {
        branch_candidate_tag_id: tagId,
      },
    )
  },
  sendOfferLetter: (
    jobCandidateId: number,
    payload: RecruitmentOfferPayload,
  ) => {
    return axiosForGigbaseBiz.post<DataResponse<void>>(
      `${resource}/${jobCandidateId}/offer_letter`,
      payload,
    )
  },
  updateStaff: (params: JobCandidateStaffUpdatePayload) => {
    return axiosForGigbaseBiz.patch<DataResponse<CandidateDetail>>(
      mergeURL(resource, params.candidateId.toString()),
      { staff_id: params.staffId },
    )
  },
}
